<template>
    <div
        v-if="origin"
        style="text-align: center;"
    >
        <i
            class="fa fa-align-justify"
            style="font-size: 30px;"
        />
    </div>
    <div
        v-else
        :class="{active: isHovered, current: isEdited}" 
        :style="{'color': computedFgColor, 'font-size': computedFontSize}"
        @mousedown="triggerFocus($event, data.id)"
    >
        <ckeditor
            v-if="isEdited"
            ref="ck"
            v-model="data.content"
            :params="editorConfig"
            :blockid="data.id"
            @input="repositionToolbar"
            @ready="repositionToolbar"
        />
        <div
            v-else
            @click.prevent=""
            v-html="data.content || 'Текст...'"
        />
    </div>
</template>

<script>
    import ComponentMixin from './Component.vue'
    import CKEditorMixin from './CKEditorMixin.vue'

    export default {
        name: 'Editable',
        mixins: [ComponentMixin, CKEditorMixin],
        data: function() {
            return {
                content: this.data.content || '',
                editorConfig: {
                    toolbar: [
                        { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'TextColor', ] },
                        { name: 'styles', items: ['Font', 'FontSize'] },
                        { name: 'links', items: ['UtmLink', 'UtmUnlink'] },
                        { name: 'paragraph', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight'] },
                        { name: 'lists', items: [ 'NumberedList', 'BulletedList'] },
                        { name: 'colors', items: ['EmojiList',  'CustomTag']},
                        { name: 'format', items: ['RemoveFormat']},
                    ],
                    language: 'ru',
                    disableNativeSpellChecker: true,
                    extraPlugins: 'templatetag,sharedspace,emojilist,utmlink,closedialogoutside,onchange,sourcedialog', 
                    font_names: 'Sans; Serif; Monospace; Fantasy;',
                    forcePasteAsPlainText: true,
                    enterMode : CKEDITOR.ENTER_BR,
                    shiftEnterMode: CKEDITOR.ENTER_BR,
                    font_defaultLabel: 'Шрифт',
                    removePlugins: 'elementspath,resize,emoji,link,sourcearea,balloonpanel,balloontoolbar,scayt,lineheight',
                    removeButtons: '',
                    resize_enabled: false,
                    template_tags: this.$root.templateTags, 
                    sharedSpaces: {top: 'ckeditor-container'},
                    fillEmptyBlocks: false,
                    tabSpaces: 0,
                    forcePasteAsPlainText: true,
                    utm_medium: this.$root.utm_medium,
                    utm_source: this.$root.utm_source,
                    utm_campaign: this.$root.utm_campaign,
                    utm_content: this.data.id,
                    emoji: this.$root.emoji,
                    emojiKey: this.$root.siteId, 
                },
             }
        },
        watch: {
            content: {
                handler: function(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.update(this.data.id, this.data);
                    }
                }
            },
            triggered: {
                handler: function(newVal, oldVal) {
                    if (newVal) {
                        this.isEdited = true;
                    } else {
                        this.isEdited = false;
                    }
                }
            },
            isEdited: {
                handler: function(newVal, oldVal) {
                    this.setContrastingFgColor(this.$el);
                }
            },
        },
        mounted: function() {
            let palette = [];
            if (this.$root.palette) {
                for (let c of this.$root.palette) {
                    palette.push(c.replace('#', ''));
                }   
                this.editorConfig.colorButton_colors = palette.join(','); 
            }
            this.setFont();
        },
        updated: function() {
            this.setFont();
        },
        methods: {
            setFont: function() {
                this.setContrastingFgColor(this.$el);
                let fs = window.getComputedStyle(this.$el, null).getPropertyValue("font-size");
                if (parseInt(fs) <= 1) {
                    this.computedFontSize = '12px'; 
                } else {
                    this.computedFontSize = fs; 
                }
            }
        }
    }
</script>
